import moment from 'moment'
import i18n from '@/Plugin/i18n';
export default class Helpers {
    static Codes = {
       
    }
    static Money = {
        decimal: '.',
        thousands: ',',
        prefix: '',
        precision: 2,
        masked: false
      }
    static Filters = {
        Empty: process.env.VUE_APP_EMPTY_TEXT || "--No especificado",
        Sexo(sex: 'M' | 'F') {
            return sex === 'M' ? 'Masculino' : 'Femenino';
        },
        EstadoCivil(value: 'S' | 'C') {
            return value === 'S' ? 'Soltero' : 'Casado';
        },
        Translate(key: string){
            if (!key) 
                return '';
              return i18n.t(key);
        },
        EdadText(value: string) {
            let years = moment().diff(value, 'years', false);
            if (years >= 1) {
                let t = years > 1 ? 'años' : 'año';
                return `${years} ${t}`
            }
            let months = moment().diff(value, 'months', false);
            if (months >= 1) {
                let t = months > 1 ? 'meses' : 'mes';
                return `${months} ${t}`
            }
            let days = moment().diff(value, 'days', false);
            if (days >= 1) {
                let t = days > 1 ? 'dias' : 'dia';
                return `${days} ${t}`
            }
            let hours = moment().diff(value, 'hours', false);
            if (hours >= 1) {
                let t = hours > 1 ? 'horas' : 'hora';
                return `${hours} ${t}`
            }
            return value;
        },
        Edad(value: string) {
            let years = moment().diff(value, 'years', false);
            if (years >= 1)
                return years;
            let months = moment().diff(value, 'months', false);
            if (months >= 1)
                return months;
            let days = moment().diff(value, 'days', false);
            if (days > 1)
                return days;
            let hours = moment().diff(value, 'hours', false);
            if (hours >= 1)
                return hours;
            return 0;
        },
        FromNow(value: string) {
            return moment(value).fromNow();
        },
        Cedula(cedula: string) {
            if (cedula && cedula.length == 11) {
                let prefijo = cedula.substring(0, 3).concat("-");
                let medio = cedula.substring(3, 10).concat("-");
                let sufijo = cedula.substring(10, 11);
                let result = prefijo.concat(medio).concat(sufijo);
                return result;
            }
            return cedula;
        }

    }
}
